import { gql } from "@apollo/client";

export const INVALIDATE_CACHE = gql`
  mutation resetCache {
    resetCache
  }
`;

export const SAVE_STRING_TRANSLATIONS = gql`
  mutation saveStringTranslations($input: StringTranslationsInput!) {
    saveStringTranslations(input: $input) {
      languageCode
      strings {
        countryCode
        key
        defaultValue
        value
      }
    }
  }
`;

export const TRANSLATIONS_FILE = gql`
  mutation translationsFile($languageCode: String!, $file: Upload!) {
    translationsFile(languageCode: $languageCode, file: $file) {
      languageCode
      strings {
        countryCode
        key
        defaultValue
        value
      }
    }
  }
`;
